import React, { useState } from "react";
import { Box } from "@mui/material";
import AssessmentLayout from "./Assessment";
import TableComponent, { CandidateEntry } from "./Table";
import DashboardHeader from "./DashboardHeader";
import { getFolderNameFromURL } from "@/utils/getFolderId";
import styles from './styles.module.css'

const DashboardContainer: React.FC = () => {
  const [assessmentId, setAssessmentId] = React.useState<string | null>("");
  const [assessmentList, setAssessmentList] = useState<any[]>([]);

  const tableData: CandidateEntry[] = [
    // Sample data remains unchanged
  ];

  return (
   <Box>
     <DashboardHeader folderName={getFolderNameFromURL()}
     assessmentCount={assessmentList?.length}
    /> 
    <Box className={styles.last_refreshed}>
    Status is updated every 3 hours
    </Box>

     <Box
      className={styles.body_container}
    >
      {/* Left Assessment Layout */}
      <AssessmentLayout setAssessmentId={setAssessmentId} assessmentCampaignId={assessmentId} 
      setAssessmentList={setAssessmentList} assessmentList={assessmentList}
      />

      {/* Right Table Component */}
      <TableComponent assessmentCampaignId={assessmentId} />
    </Box>
   </Box>
  );
};

export default DashboardContainer;
